module.exports = __webpack_public_path__ + "img/new_logo_abbreviated.7d5b91ec.svg";